/**
 * 文件夹 Grid 视图布局常量 · 单一数据源
 *
 * 这些值同时被三处取用，必须保持一致：
 *  · CSS（FolderList.module.scss 的 --folder-card-col / --folder-grid-gap / --folder-card-height）
 *  · react-virtualized Grid（columnWidth / rowHeight）
 *  · 框选几何模型（rectsFromGridLayout 的入参）
 * 改尺寸只改这一处 + 对应 CSS 变量。
 */

/** 卡片宽（与 CSS --folder-card-col 同值） */
export const CARD_WIDTH = 208
/** 宫格行/列间距（与 CSS --folder-grid-gap 同值） */
export const GRID_GAP = 16
/** Grid 列槽宽 = 卡宽 + 间距 */
export const COLUMN_WIDTH = CARD_WIDTH + GRID_GAP // 224

/**
 * 卡片固定高 · 与 CSS --folder-card-height 同值。
 * 取自实测的卡片自然高度，锁定后卡片不再随内容伸缩。
 */
export const CARD_HEIGHT = 200
/** Grid 行槽高 = 卡高 + 间距 */
export const GRID_ROW_HEIGHT = CARD_HEIGHT + GRID_GAP // 216

/**
 * 列表（表格）视图固定行高 · 与 CSS --folder-row-height 同值。
 * react-virtualized List 的 rowHeight 取此值；FolderRow 用 box-sizing:border-box
 * 固定到同一高度（内容 = 54 - 上下 padding 20 - 底部分割线 1 = 33，容得下 endSlot 32）。
 */
export const TABLE_ROW_HEIGHT = 54
